module.exports = __webpack_public_path__ + "static/img/recommed-Flash.d3148b5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/recommed-Flash.gif
// module id = qTeu
// module chunks = 1